/**
 * adding setup for AJAX
 */
define('common/ajaxConfig',['jquery'], function($) {
	'use strict';
	//	setting jsonp to false by default
    $.ajaxSetup({
        jsonp: false,
    });
});
